const DEFAULT_BY_PASS_OTP_NUMBERS = ["1", "1", "1", "1", "1", "1"];

export function doesOtpMatchDefaultByPassOtp(otp) {
  return otp.every(
    (value, index) => value === DEFAULT_BY_PASS_OTP_NUMBERS[index]
  );
}
